export var DiscountScope;
(function (DiscountScope) {
    DiscountScope["All"] = "all";
    DiscountScope["Single"] = "single";
    DiscountScope["Group"] = "group";
})(DiscountScope || (DiscountScope = {}));
export const ProductKinds = {
    MENU: 'menu',
    SINGLE: 'single',
    INGREDIENS: 'ingrediens',
};
